<template>
    <div>
        <InProcessMedicalNote
            v-if="reportId == CREPORT.TYPE.IN_PROCESS_MEDICAL_NOTES"
            :data="data"
        />
        <ActivePatientList
            v-if="reportId == CREPORT.TYPE.ACTIVE_PATIENT_LIST"
            :data="data"
        />
        <DeceasedPatientList
            v-if="reportId == CREPORT.TYPE.DECEASED_PATIENT_LIST"
            :data="data"
        />
        <InactivePatientList
            v-if="reportId == CREPORT.TYPE.INACTIVE_PATIENT_LIST"
            :data="data"
        />
        <NewPatients
            v-if="reportId == CREPORT.TYPE.NEW_PATIENTS"
            :data="data"
        />
        <DiagnosisSummaryList
            v-if="reportId == CREPORT.TYPE.DIAGNOSIS_SUMMARY_LIST"
            :data="data"
        />
        <RabiesSummary
            v-if="reportId == CREPORT.TYPE.RABIES_SUMMARY"
            :data="data"
        />
        <TotalPatients
            v-if="reportId == CREPORT.TYPE.TOTAL_PATIENTS"
            :data="data"
        />
        <SpeciesDistribution
            v-if="this.$route.params.id == CREPORT.TYPE.SPECIES_DISTRIBUTION"
            :data="data"
        />
        <PatientBirthdays
            v-if="reportId == CREPORT.TYPE.PATIENT_BIRTHDAYS"
            :data="data"
        />
        <ActiveEngagedPatient
            v-if="reportId == CREPORT.TYPE.ACTIVE_ENGAGED_PATIENT"
            :data="data"
        />
    </div>
</template>
<script>
import CREPORT from "@/constants/report.js";
import InProcessMedicalNote from "@/module/report/module/patient/in-process-medical-notes";
import ActivePatientList from "@/components/report-patient/active-patient-list";
import DeceasedPatientList from "@/components/report-patient/deceased-patient-list";
import InactivePatientList from "@/components/report-patient/inactive-patient-list";
import NewPatients from "@/components/report-patient/new-patients";
import DiagnosisSummaryList from "@/components/report-patient/diagnosis-summary-list";
import RabiesSummary from "@/components/report-patient/rabies-summary";
import TotalPatients from "@/components/report-patient/total-patients";
import SpeciesDistribution from "@/components/report-patient/species-distribution";
import PatientBirthdays from "@/components/report-patient/patient-birthdays";
import ActiveEngagedPatient from "@/components/report-patient/active-engaged-patient";

export default {
    components: {
        InProcessMedicalNote,
        ActivePatientList,
        DeceasedPatientList,
        InactivePatientList,
        NewPatients,
        DiagnosisSummaryList,
        RabiesSummary,
        TotalPatients,
        SpeciesDistribution,
        PatientBirthdays,
        ActiveEngagedPatient
    },
    computed: {
        reportId() {
            return this.$route.params.id;
        }
    },
    props: {
        data: {
            default() {},
            type: Object
        }
    },
    data() {
        return { CREPORT: CREPORT };
    }
};
</script>
